<template>
  <div>
    <v-tooltip bottom>
      <span slot="activator">
        <v-btn small icon @click.stop="handleRestartButtonClick">
          <v-icon small>fa-redo</v-icon>
        </v-btn>
      </span>
      Restart Work (add new services)
    </v-tooltip>

    <v-dialog max-width="800" persistent v-if="showModal" v-model="showModal">
      <v-card v-if="!caseInfo && showModal">
        Loading...
      </v-card>
      <v-card v-else>
        <v-card-title class="headline">Restart case to work</v-card-title>
        <v-card-text>
          <v-form ref="form" v-model="isValid">
            <v-layout align-center
              v-for="addedService in form.services"
              v-bind:key="form.services.id"
            >
              <v-flex xs2>
                <service-as-badge :service-id="addedService.serviceId"/>
              </v-flex>
              <v-flex xs2>
                <number-input :max-value="100" :min-value="1" v-model="addedService.quantity"/>
              </v-flex>
              <v-btn @click="handleRemoveService(addedService)" icon small>
                <v-icon small>fa-trash</v-icon>
              </v-btn>
            </v-layout>

            <service-select
              :service-filter="filterService"
              @input="handleAddService"
              v-if="showSelectService"/>

            <v-text-field :rules="ecdcHoursRules"
                          label="Hours"
                          placeholder="How many hours you want to append?"
                          v-model="form.additionalHours"
            />

            <v-radio-group :rules="ecdcModeRules" row v-model="form.ecdcMode">
              <v-radio label="Add to estimated datetime" value="estimated"/>
              <v-radio label="Add to current time" value="now"/>
            </v-radio-group>

            <v-text-field label="Comment" v-model="form.comment"/>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn @click="handleHideForm">Cancel</v-btn>
          <v-btn :disabled="!isSubmitEnabled"
                 :loading="requestInProgress"
                 @click="handleFormSubmit">Restart
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {mapActions} from 'vuex'
import {notificationService} from '../../application'
import ServiceSelect from '../Ui/mcc/ServiceSelect'
import NumberInput from '../Ui/NumberInput'
import DateTimeInput from '../Ui/DateTimeInput'
import ServiceInfo from '../analytics/ServiceInfo'
import ServiceAsBadge from '../Ui/mcc/ServiceAsBadge'
import {isNumeric} from '../../helpers/types'

function getDefaultFormData() {
  return {
    additionalHours: 48,
    ecdcMode: 'estimated',
    services: [],
    comment: null
  }
}

export default {
  name: 'restart-case-to-work-form',
  components: {
    ServiceAsBadge,
    ServiceInfo,
    ServiceSelect,
    NumberInput,
    DateTimeInput
  },
  props: {
    caseId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      isValid: false,
      showModal: false,
      form: getDefaultFormData(),
      serviceRules: [
        v => !!v || 'Can\'t be null'
      ],
      showSelectService: true, // hacky way to fix vuetify open autoSelect
      requestInProgress: false,
      ecdcHoursRules: [
        (value) => {
          if (!isNumeric(value)) {
            return 'Hours must be numeric'
          }

          return true
        }
      ],
      ecdcModeRules: [
        v => !!v || 'Please select mode'
      ]
    }
  },
  computed: {
    caseInfo() {
      return this.$store.getters.getCaseInfoById(this.caseId)
    },
    availableServicesForClient() {
      if (!this.caseInfo || !this.caseInfo.response) { // case not loaded yet
        return []
      }

      return this.$store.getters.getClientServicesNotHidden(this.caseInfo.response.clientId)
    },
    isSubmitEnabled() {
      const valid = this.isValid && this.form.services.length > 0
      if (!valid) {
        return false
      }
      if (this.$refs.form && !this.$refs.form.validate()) {
        return false
      }

      return true
    }
  },
  mounted() {
    this.fetchCaseByIdIfRequired(this.caseId)
  },
  watch: {
    showModal() {
      if (!this.showModal) {
        this.resetForm()
      }
    }
  },
  methods: {
    ...mapActions({
      fetchCaseByIdIfRequired: 'fetchCaseByIdIfRequired',
      submitForm: 'caseServiceLogRestartCaseToWork'
    }),
    handleRestartButtonClick() {
      this.fetchCaseByIdIfRequired(this.caseId)
      this.handleShowForm()
    },
    handleShowForm() {
      this.showModal = true
    },
    handleHideForm() {
      this.showModal = false
    },
    handleFormSubmit() {
      if (!this.$refs.form.validate()) {
        return
      }

      const request = {
        caseId: this.caseId,
        services: this.form.services,
        comment: this.form.comment,
        additionalHours: parseInt(this.form.additionalHours),
        ecdcMode: this.form.ecdcMode
      }

      this.requestInProgress = true

      this
        .submitForm(request)
        .then(() => {
          this.requestInProgress = false
          notificationService.info('Operation success')
          this.showModal = false
        })
        .catch(e => {
          this.requestInProgress = false
          notificationService.error('Operation failed')
          throw e
        })
    },
    resetForm() {
      this.form = getDefaultFormData()
    },
    filterService(service) {
      if (this.availableServicesForClient.indexOf(service.id) < 0) {
        return false
      }

      const alreadyAddedService = _.find(this.form.services, addedService => addedService.id === service.id)
      if (alreadyAddedService) {
        return false
      }

      return true
    },
    handleAddService(serviceId) {
      this.showSelectService = false
      this.$nextTick(() => {
        this.showSelectService = true
      })

      this.form.services.push({
        serviceId: serviceId,
        quantity: 1
      })
    },
    handleRemoveService(serviceForRemove) {
      this.form.services = _.filter(this.form.services, it => it.serviceId !== serviceForRemove.serviceId)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/case/RestartCaseToWorkForm.vue